import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import type { ButtonSize, ButtonVariant } from "./Button";
import { cx } from "./cx";
import styles from "./Button.module.css";

export type ButtonLinkProps = LinkProps & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  fullWidth?: boolean;
};

/**
 * Un lien habillé en bouton : mêmes variantes, mêmes tailles, même cible que
 * `Button`, mais c'est une navigation — donc un `<a>`, qui s'ouvre dans un
 * nouvel onglet, se copie et se lit comme un lien par l'assistance technique.
 * Un `<button>` qui appelle `navigate()` perdrait tout ça.
 */
export function ButtonLink({
  variant = "secondary",
  size = "md",
  iconLeft,
  iconRight,
  fullWidth = false,
  className,
  children,
  ...rest
}: ButtonLinkProps) {
  return (
    <Link
      className={cx(
        styles.bouton,
        styles[variant],
        size !== "md" && styles[size],
        fullWidth && styles.fullWidth,
        className,
      )}
      {...rest}
    >
      {iconLeft && (
        <span className={styles.icone} aria-hidden="true">
          {iconLeft}
        </span>
      )}
      {children}
      {iconRight && (
        <span className={styles.icone} aria-hidden="true">
          {iconRight}
        </span>
      )}
    </Link>
  );
}
